import React from 'react';
import AuthService from './authService';
import CommissionLineItem from '../Domain/CommissionLineItem';
import CommissionLineDetailItem from '../Domain/CommissionLineDetailItem';
import SearchParams from '../Elements/SearchParams';
import CommissionLineSearchParams from '../Contents/Sales/CommissionLine/CommissionLineSearchParams';
import CommissionLineDetailSearchParams from '../Contents/Sales/CommissionLine/CommissionLineDetailSearchParams';

export default class CommissionLineService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, CommissionLineSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/CommissionLine/GetListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static GetDetailListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, CommissionLineDetailSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/CommissionLine/GetDetailListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CommissionLineItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertDBDetailItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CommissionLineDetailItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ExportAdminExcelAsync(searchItem) {
    const url = `/api/CommissionLine/ExportAdminExcelAsync?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static UpsertItem(item) {
    const url = `/api/CommissionLine/UpsertAsync`;
    const commissionLineJson = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPost(url, commissionLineJson);
  }

  static RemoveItem(id, userId) {
    const url = `/api/CommissionLine/DeleteAsync/?lineId=${id}&userId=${userId}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }
}
